/**
 * Script for Front Page
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

/**
 * Top Visual
 *
 * @author Space-Time Inc.
 */

document.addEventListener('DOMContentLoaded', () => {
	const root = document.getElementsByClassName('part-top-visual')[0];
	if (!root) return;

	const cs = root.getElementsByClassName('caption');
	const m  = root.querySelector('.methodology');

	const rods = [...m.querySelectorAll('.rods .rod')];
	const caps = [...m.querySelectorAll('.caps .cap')];

	// for test
	// increaseItemsForTest(rods, caps, 16);

	for (let i = 0; i < rods.length; i += 1) {
		const rod = rods[i];
		const cap = caps[i];
		for (const t of [rod, cap]) {
			t.addEventListener('mouseenter', () => setAnimationState(true, rod, cap));
			t.addEventListener('mouseleave', () => setAnimationState(false, rod, cap));
			t.addEventListener('touchstart', () => setAnimationState(true, rod, cap));
			t.addEventListener('touchend',   () => setAnimationState(false, rod, cap));
		}
	}
	function setAnimationState(flag, rod, cap) {
		rod.classList[flag ? 'add' : 'remove']('pause');
		cap.classList[flag ? 'add' : 'remove']('pause');
	}

	setTimeout(() => {
		root.classList.add('start');
	}, 100);

	setTimeout(() => {
		layOut();
		const lastClientSize = { w: 0, h: 0 };
		window.addEventListener('resize', throttle(() => {
			setTimeout(() => {
				if (lastClientSize.w === m.clientWidth && Math.abs(lastClientSize.h - m.clientHeight) < 32) return;
				lastClientSize.w = m.clientWidth;
				lastClientSize.h = m.clientHeight;
				layOut();
			}, 100);
		}), { passive: true });
	}, 400);

	setTimeout(() => {
		for (const rod of rods) rod.style.opacity = 1;
		for (const cap of caps) cap.style.opacity = 1;
	}, 400);


	// -------------------------------------------------------------------------


	const ioOpts = {
		rootMargin: '0px',
		threshold : 0.2,
	};
	const io = new IntersectionObserver(es => {
		es.forEach(e => {
			if (e.isIntersecting) {
				root.classList.add('start');
			} else {
				root.classList.remove('start');
			}
		});
	}, ioOpts);
	io.observe(root);


	// -------------------------------------------------------------------------


	function increaseItemsForTest(rods, caps, num) {
		const a = 0 | Math.floor(num / rods.length);

		const mr = document.querySelector('.methodology .rods');
		const mc = document.querySelector('.methodology .caps');
		loop: for (const r of [...rods]) {
			for (let i = 0; i < a; i += 1) {
				const c = r.cloneNode(true);
				mr.appendChild(c);
				rods.push(c);
				if (rods.length === num) break loop;
			}
		}
		loop: for (const r of [...caps]) {
			for (let i = 0; i < a; i += 1) {
				const c = r.cloneNode(true);
				mc.appendChild(c);
				caps.push(c);
				if (caps.length === num) break loop;
			}
		}
	}


	// -------------------------------------------------------------------------


	function layOut() {
		const aspect = m.clientHeight / m.clientWidth;
		const arc4   = Math.PI * (m.clientHeight + m.clientWidth) / 4;
		const step   = calcDegreeStep(rods.length, m);

		const areaRate = (700000 < m.clientHeight * m.clientWidth) ? 1.6 : 1.2;

		for (let i = 0; i < rods.length; i += 1) {
			const rod = rods[i];
			const cap = caps[i];
			const deg = i * step;
			const rad = deg * Math.PI / 180;

			rod.style.setProperty('--rot', `${round(deg)}deg`);
			cap.style.setProperty('--rot', `${round(deg)}deg`);

			const rate = radToRate(rad, aspect);
			rod.style.setProperty('--width', `${round(rate * 100)}%`);
			cap.style.setProperty('--width', `${round(rate * 100)}%`);

			const h = arc4 * step / 90 * areaRate;
			rod.style.setProperty('--height', `${round(h * Math.max(0.5, rate))}px`);
			cap.style.setProperty('--height', `${round(h * Math.max(0.5, rate))}px`);

			// ----

			const coff = parseInt(getComputedStyle(cs[i]).marginInlineStart, 10);
			const cw   = cs[i].clientWidth ?? 0;

			const mw  = rod.clientWidth - (coff + cw);
			const min = 1 - mw / rod.clientWidth + 0.1;
			const mid1 = min + (1 - min) * 0.30;
			const mid2 = min + (1 - min) * 0.64;
			rod.style.setProperty('--min-scale', min);
			rod.style.setProperty('--mid-1-scale', mid1);
			cap.style.setProperty('--mid-1-scale', mid1);
			rod.style.setProperty('--mid-2-scale', mid2);
			cap.style.setProperty('--mid-2-scale', mid2);

			const m = rod.getElementsByClassName('method')[0];
			const r = rod.getElementsByClassName('result')[0];
			const l = cap.getElementsByClassName('line')[0];

			const rde = (i % 2 ? -16000 : 0) - round(randRange(0, 1000));
			m.style.setProperty('--delay', rde + 'ms');
			m.style.setProperty('--duration', '32000ms');
			r.style.setProperty('--delay', rde + 'ms');
			r.style.setProperty('--duration', '32000ms');
			l.style.setProperty('--delay', rde + 'ms');
			l.style.setProperty('--duration', '32000ms');
		}
	}

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	


	// -------------------------------------------------------------------------


	function calcDegreeStep(num, m) {
		const bcr = m.getBoundingClientRect();

		let r;
		for (r = 1; r <= 3; r += 1) {
			const d = 90 / (num - r);
			const l = (r - 0.25) * m.clientHeight * Math.sin(d * Math.PI / 180);
			if (bcr.x < l) break;
		}
		return 90 / (num - r);
	}

	function randRange(min, max) {
		return min + (max - min) * Math.random();
	}

	function round(v) {
		return Math.round(v * 100) / 100;
	}

	function radToRate(rad, aspect) {
		const { x, y } = calcIntersection(rad, aspect);
		return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
	}

	function calcIntersection(rad, aspect) {
		if (Math.abs(rad - Math.PI / 2) < 0.001) return { x: 0, y: aspect };
		const t = Math.tan(rad);
		for (let i = 0;; i += 1) {
			const x = i * 0.001 * (rad < Math.PI / 2 ? 1 : -1);
			const y = t * x;
			const y2 = aspect - aspect * (x < 0 ? Math.pow(x, 2) : Math.pow(x, 8));
			if (y2 < y) {
				return { x, y };
			}
			if (1 < x) break;
		}
		return { x: 0, y: 0 };
	}

});

